import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import CurrencyInput from 'react-currency-input-field';

import { setAlert } from '../../actions/alert';
import { crearCita, buscarHorariosCita, buscarContrataciones } from '../../actions/citas';
import { buscarClientes } from '../../actions/clientes';
import { buscarLocatarios } from '../../actions/locatarios';

import { CustomValueContainer } from '../../components/react_select/ReactSelect';

const NuevaCita = ({ cita, reestablecerCita }) => {

    const dispatch =  useDispatch();

    const { listado: listado_clientes } = useSelector(state => state.clientes);
    const { listado: listado_locatarios } = useSelector(state => state.locatarios);
    const { listado_horarios_cita, listado_contrataciones } = useSelector(state => state.citas);
    const { usuario } = useSelector(state => state.auth);

    const [nuevoModal, setNuevoModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    const [citaData, setCitaData] = useState({
        id_cliente: null,
        id_locatario: null,
        id_servicio: null,
        id_contratacion: null,
        total: null,
        metodo: null,
        fecha: null,
        hora_inicio: null,
        hora_fin: null,
        observaciones: null
    });

    const [clienteData, setClienteData] = useState(null);
    const [clientesFilter, setClientesFilter] = useState([]);

    const [locatarioData, setLocatarioData] = useState(null);
    const [locatariosFilter, setLocatariosFilter] = useState([]);

    const [servicioData, setServicioData] = useState(null);
    const [serviciosFilter, setServiciosFilter] = useState([]);

    const [contratacionData, setContratacionData] = useState(null);
    const [contratacionesFilter, setContratacionesFilter] = useState([]);

    const [metodoData, setMetodoData] = useState(null);
    const todosMetodos = [
        { value: 0, label: 'Efectivo' },
        { value: 1, label: 'Tarjeta' },
        { value: 2, label: 'Transferencia' }
    ];
    const [metodosFilter, setMetodosFilter] = useState(todosMetodos);

    const [horarioData, setHorarioData] = useState(null);
    const [horariosFilter, setHorariosFilter] = useState([]);

    let styles_select = {
        menuPortal: base => ({ ...base, zIndex: 9999 }), 
        container: (provided, state) => ({
            ...provided, 
        }),
        control: (provided, state) => ({
            ...provided,
            paddingTop: '5px',
            paddingBottom: '5px',
        }),
        valueContainer: (provided, state) => ({
            ...provided,
            overflow: "visible", 
            marginTop: "10px"
        }),
        placeholder: (provided, state) => ({
            ...provided,
            position: "absolute",
            top: state.hasValue || state.selectProps.inputValue ? -15 : "0%",
            transition: "top 0.1s, font-size 0.1s",
            fontSize: (state.hasValue || state.selectProps.inputValue) && 13
        })
    };

    /* Crear cita */
    const handleAbrir = () => {
        dispatch(buscarClientes({
            nombre: null,
            apellido_paterno: null,
            apellido_materno: null,
            celular: null,
            email: null
        }));

        dispatch(buscarLocatarios({
            nombre: null,
            servicio: null,
            status: null,
            fecha_inicio: null,
            fecha_fin: null
        }));
    }

    const handleSelectCliente = (option) => {
        setClienteData(option);

        setCitaData({
            ...citaData,
            id_cliente: option ? option.value : null
        });
    }

    const handleSelectLocatario = (option) => {
        setLocatarioData(option);
        setServicioData(null);
        setMetodoData(null);
        setHorarioData(null);

        setCitaData({
            ...citaData,
            id_locatario: option ? option.value : null,
            id_servicio: null,
            total: null,
            metodo: null,
            fecha: null,
            hora_inicio: null,
            hora_fin: null
        });

        let options = [];

        if(option){
            for (var i = 0; i < option.servicios?.length; i++) {
                options.push({ value: option.servicios[i]._id, label: option.servicios[i].nombre, precio: option.servicios[i].precio, intervalo_cita: option.servicios[i].intervalo_cita });
            }
        }

        setServiciosFilter(options);
        setHorariosFilter([]);

        const metodos = option?.metodos_pago?.length
            ? todosMetodos.filter(m => option.metodos_pago.includes(m.value))
            : todosMetodos;
        setMetodosFilter(metodos);
    }

    const handleSelectServicio = (option) => {
        setServicioData(option);
        setContratacionData(null);
        setMetodoData(null);
        setHorarioData(null);

        setCitaData({
            ...citaData,
            id_servicio: option ? option.value : null, 
            id_contratacion: null, 
            total: option ? option.precio : 0, 
            metodo: null,
            fecha: null,
            hora_inicio: null,
            hora_fin: null
        });

        setContratacionesFilter([]);
        setHorariosFilter([]);

        if(option){
            dispatch(buscarContrataciones({
                id_cliente: citaData.id_cliente, 
                id_servicio: option ? option.value : null, 
                id_contratacion: null
            }));
        }
    }

    const handleSelectContratacion = (option) => {
        setContratacionData(option);
        setMetodoData(null);

        setCitaData({
            ...citaData,
            id_contratacion: option ? option.value : null, 
            metodo: null
        });
    }

    const handleInputChange = ({ target }) => {
        setCitaData({
            ...citaData,
            [target.name]: target.value
        });
    }

    const handleSelectMetodo = (option) => {
        setMetodoData(option);

        setCitaData({
            ...citaData,
            metodo: option ? option.value : null
        });
    }

    const handleDatePicker = (name, value) => {
        setCitaData({
            ...citaData,
            [name]: value, 
            hora_inicio: null,
            hora_fin: null
        });

        setHorarioData(null);

        if(value){
            dispatch(buscarHorariosCita({
                id_cita: null, 
                id_locatario: citaData.id_locatario, 
                id_servicio: citaData.id_servicio, 
                fecha: value
            }));
        }
    }

    const handleSelectHorario = (option) => {
        setHorarioData(option);

        setCitaData({
            ...citaData,
            hora_inicio: option ? option.hora_inicio : null,
            hora_fin: option ? option.hora_fin : null
        });
    }
    
    const handleProcesar = async () => {
        if(citaData.id_cliente){
            if((citaData.metodo == null && citaData.id_contratacion) || (citaData.metodo != null && !citaData.id_contratacion)){
                if(citaData.fecha){
                    if(citaData.hora_inicio <= citaData.hora_fin){
                        await setStatusProcesar(true);
                        await dispatch(crearCita(citaData));
                        await handleCerrar();
                        await setStatusProcesar(false);
                    }else{
                        await dispatch(setAlert('La hora de inicio debe ser menor o igual a la de finalización', 'danger'));
                    }
                }else{
                    await dispatch(setAlert('La fecha de la cita es requerida', 'danger'));
                }
            }else{
                await dispatch(setAlert('Se debe de elegir un método de pago o un paquete', 'danger'));
            }
        }else{
            await dispatch(setAlert('Ingresa el cliente al que se le reservará', 'danger'));
        }
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            setCitaData({
                id_cliente: null,
                id_locatario: null,
                id_servicio: null,
                id_contratacion: null, 
                total: null,
                metodo: null,
                fecha: null,
                hora_inicio: null,
                hora_fin: null,
                observaciones: null
            });

            setClienteData(null);
            setLocatarioData(null);
            setServicioData(null);
            setContratacionData(null);
            setMetodoData(null);
            setHorarioData(null);
            setNuevoModal(false);
            reestablecerCita(null);
        }
    }

    useEffect(() => {
        if(cita){
            setNuevoModal(true);

            setCitaData({
                ...citaData
            });
        }        
    }, [cita]);

    useEffect(() => {
        let options = [];

        for (var i = 0; i < listado_clientes?.length; i++) {
            options.push({ value: listado_clientes[i]._id, label: [listado_clientes[i].nombre, listado_clientes[i].apellido_paterno, listado_clientes[i].apellido_materno].join(' ') });
        }

        setClientesFilter(options);
    }, [listado_clientes]);

    useEffect(() => {
        let options = [];

        for (var i = 0; i < listado_locatarios?.length; i++) {
            options.push({ value: listado_locatarios[i]._id, label: `${listado_locatarios[i].servicio} (${listado_locatarios[i].nombre})`, servicios: listado_locatarios[i].servicios, metodos_pago: listado_locatarios[i].metodos_pago });
        }

        console.log(usuario);

        if(usuario?.tipo == 2){
            options = options.filter(o => o.value === usuario.locatario);
            if(options.length === 1){
                handleSelectLocatario(options[0]);
            }
        }

        setLocatariosFilter(options);
    }, [listado_locatarios]);

    useEffect(() => {
        let options = [];

        for (var i = 0; i < listado_horarios_cita.length; i++) {
            options.push({ value: i, label: [listado_horarios_cita[i].hora_inicio, listado_horarios_cita[i].hora_fin].join(' - '), hora_inicio: listado_horarios_cita[i].hora_inicio, hora_fin: listado_horarios_cita[i].hora_fin });
        }

        setHorariosFilter(options);
    }, [listado_horarios_cita]);

    useEffect(() => {
        let options = [];

        if(listado_contrataciones.length){
            options = [{ value: null, label: 'Sin paquete elegido' }];

            for (var i = 0; i < listado_contrataciones.length; i++) {
                options.push({ value: listado_contrataciones[i].id_contratacion, label: listado_contrataciones[i].nombre_paquete + ' (' + listado_contrataciones[i].citas_disponibles + ' cita' + (listado_contrataciones[i].citas_disponibles == 1 ? ' disponible)' : ' disponibles)') });
            }

            setContratacionData({ value: null, label: 'Sin paquete elegido' });
        }else{
            options = [{ value: null, label: 'No hay paquetes disponibles' }];

            setContratacionData({ value: null, label: 'No hay paquetes disponibles' });
        }

        setContratacionesFilter(options);
    }, [listado_contrataciones]);

    return (
        <Modal show={nuevoModal} size="xl" backdrop="static" centered onEntered={() => handleAbrir()} onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Agregar cita</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-5 form-group mb-3">
                        <div className="input-group contenedor-select">
                            <Select
                                id="id_cliente"
                                name="id_cliente"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Seleccionar cliente"
                                isClearable
                                options={clientesFilter}
                                value={clienteData}
                                onChange={(value) => handleSelectCliente(value)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                            />
                        </div>
                    </div>

                    <div className="col-md-7 form-group mb-3">
                        <div className="input-group contenedor-select">
                            <Select
                                id="id_locatario"
                                name="id_locatario"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Seleccionar locatario"
                                isClearable
                                options={locatariosFilter}
                                value={locatarioData}
                                onChange={(value) => handleSelectLocatario(value)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                            />
                        </div>
                    </div>

                    <div className="col-md-5 form-group mb-3">
                        <div className="input-group contenedor-select">
                            <Select
                                id="id_servicio"
                                name="id_servicio"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Seleccionar servicio"
                                isClearable
                                isDisabled={!locatarioData}
                                options={serviciosFilter}
                                value={servicioData}
                                onChange={(value) => handleSelectServicio(value)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                            />
                        </div>
                    </div>

                    <div className="col-md-7 form-group mb-3">
                        <div className="input-group contenedor-select">
                            <Select
                                id="id_contratacion"
                                name="id_contratacion"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Seleccionar paquete disponible"
                                isDisabled={!servicioData || contratacionesFilter.length < 2}
                                options={contratacionesFilter}
                                value={contratacionData}
                                onChange={(value) => handleSelectContratacion(value)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                            />
                        </div>
                    </div>

                    <div className="col-md-3 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <CurrencyInput
                                    id="total"
                                    name="total"
                                    className="form-control text-center"
                                    value={citaData.total || ''}
                                    decimalsLimit={2}
                                    groupSeparator=","
                                    decimalSeparator="."
                                    disabled
                                />
                                <label htmlFor="total">Total a cobrar</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3 form-group mb-3">
                        <div className="input-group contenedor-select">
                            <Select
                                id="metodo"
                                name="metodo"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Método de pago"
                                isClearable
                                isDisabled={!servicioData || !!contratacionData?.value}
                                options={metodosFilter}
                                value={metodoData}
                                onChange={(value) => handleSelectMetodo(value)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                            />
                        </div>
                    </div>

                    <div className="col-md-3 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <DatePicker
                                    id="fecha"
                                    name="fecha"
                                    className="form-control text-center input-datepícker"
                                    dateFormat="dd/MM/yyyy"
                                    disabled={!servicioData}
                                    minDate={new Date()}
                                    selected={ citaData.fecha != null ? new Date(citaData.fecha) : '' }
                                    onChange={ date => handleDatePicker('fecha', date) }
                                />
                                <label className="label-datepicker" htmlFor="fecha">Fecha</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3 form-group mb-3">
                        <div className="input-group contenedor-select">
                            <Select
                                id="horario"
                                name="horario"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Seleccionar horario"
                                isClearable
                                isDisabled={!servicioData}
                                options={horariosFilter}
                                value={horarioData}
                                onChange={(value) => handleSelectHorario(value)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                            />
                        </div>
                    </div>

                    <div className="col-md-12 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <textarea className="form-control textareCampo" placeholder="Observaciones" id="observaciones" name="observaciones" value={citaData.observaciones} onChange={e => handleInputChange(e)}></textarea>
                                <label htmlFor="observaciones">Observaciones</label>
                            </div>
                        </div>
                    </div>
                </div>                    
            </Modal.Body>
            <Modal.Footer>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Agregar</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Agregar</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default NuevaCita;